import {
  useOnCreateConversationSubscription,
  useOnUpdateConversationSubscription
} from 'generated-graphql/hooks/apollo-hooks';
import { SearchConversationsItem } from 'modules/conversations/types';

type Props = {
  campaignId: string;
  createConversation: (newConversation: SearchConversationsItem) => void;
  updateConversation: (
    updatedConversation: SearchConversationsItem
  ) => Promise<void>;
};

export const useCampaignConversationsSubscriptions = ({
  campaignId,
  createConversation,
  updateConversation
}: Props) => {
  useOnCreateConversationSubscription({
    variables: {
      campaignId
    },
    onData: ({ data }) => {
      const conversation = data.data?.onCreateConversation;
      if (conversation) {
        createConversation(conversation);
      }
    }
  });

  useOnUpdateConversationSubscription({
    variables: {
      campaignId
    },
    onData: async ({ data }) => {
      const conversation = data.data?.onUpdateConversation;
      if (conversation) {
        await updateConversation(conversation);
      }
    }
  });
};
